<template>
  <div>
    <div class="filter">
      <el-form
        :inline="true"
        @submit.native.prevent
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="80px"
        class="oneline"
        size="small"
      >
        <el-form-item label="配件分类">
          <ItemTemplateSelect
            v-model="filter.item_template_id"
            :category="category"
            :clearable="true"
          ></ItemTemplateSelect>
        </el-form-item>
        <el-form-item label="配件编号">
          <ItemSelect
            v-model="filter.item_id"
            :category="category"
          ></ItemSelect>
        </el-form-item>
        <el-form-item label="数据类型">
          <el-select v-model="filter.data_category">
            <el-option key="0" label="不限" :value="0"></el-option>
            <el-option key="1" label="使用记录" :value="1"></el-option>
            <el-option key="2" label="维修记录" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="display: flex; justify-content: end">
      <file-button
        obj="item_life_data"
        :filter="queryData"
        :importButton="false"
      ></file-button>
    </div>
    <MyTable
      :items="items.list"
      :category="category"
      v-loading="loading"
    ></MyTable>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
  </div>
</template>

<script>
import { itemStatistics } from '@/service/getData'
import ItemSelect from './item_select'
import MyTable from './table'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    MyTable,
    ItemSelect,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.is_data_life = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        item_template_id: '',
        item_id: '',
        data_category: '',
        page: 1,
        size: 10,
        tab: 'life_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'life_data') {
        this.filter = filter
      }
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.item_template_id = ''
        this.filter.item_id = ''
        this.filter.data_category = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await itemStatistics(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>